import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { getSerialFromBarcode } from "../../../../shared/utility";
import DeveloperBarcode from "../../../controls/DeveloperBarcode";
import CopyableIdentifier from "../../../controls/CopyableIdentifier";

export default function OrderSubTable2(props) {
  const { data, loadingRows, rowDetails, selectedItems, setSelectedItems } =
    props;

  const bodyProductName = (item) => {
    return (
      <div className="flex gap-2">
        {item.is_legacy === 1 ? <p className="text-lg my-auto">L</p> : null}
        <div>
          {item.product_name} <br />{" "}
          <span className="font-bold">PLU: {item.plu}</span>
        </div>
      </div>
    );
  };

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const barcodeBody = (rowData) => {
    const returned = rowData.is_returned === 1 ? " RETURNED" : null;

    return (
      <div>
        <CopyableIdentifier
          value={rowData.barcode}
          displayValue={`${getSerialFromBarcode(rowData.barcode)}${
            returned ? ` ${returned.trim()}` : ""
          }`}
          description="full barcode"
        />
        <DeveloperBarcode value={rowData.barcode} compact />
      </div>
    );
  };

  const lotNumberBody = (rowData) => (
    <CopyableIdentifier
      value={rowData.lot_number}
      description="lot number"
    />
  );

  const weightInKg = (rowData) => {
    return <p>{rowData.net_weight_kg}kg</p>;
  };

  const weightInLbs = (rowData) => {
    return <p>{rowData.net_weight_lbs}lbs</p>;
  };

  const pieceCount = (rowData) => {
    return <p>{rowData.piece_count} pieces</p>;
  };

  const rowStyleClass = (data) => {
    return {
      "bg-yellow-100": data.is_returned === 1,
      "bg-gray-100": data.is_returned === 0,
    };
  };

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm shipping-sub-items-2-table"
        cellClassName="py-2 border-1-bottom-gray px-2 text-sm"
        rowClassName={rowStyleClass}
        selectionMode="checkbox"
        selection={selectedItems}
        onSelectionChange={(e) => setSelectedItems(e.value)}
      >
        <Column
          header="Product"
          body={bodyProductName}
          style={{ width: "20%" }}
        />
        <Column
          header="Lot Number"
          body={lotNumberBody}
          style={{ width: "15%" }}
        />
        <Column header="Serial" body={barcodeBody} style={{ width: "20%" }} />
        <Column
          header="Weight in kg"
          body={weightInKg}
          style={{ width: "15%", textAlign: "right" }}
        />
        <Column
          header="Weight in lbs"
          body={weightInLbs}
          style={{ width: "15%", textAlign: "right" }}
        />
        <Column
          header="Piece count"
          body={pieceCount}
          style={{ width: "15%", textAlign: "right" }}
        />
      </DataTable>
    </div>
  );
}
